module.exports = __webpack_public_path__ + "img/selected0-min.00bf60f8.png";